import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review from Beefy's Own's live Faire brand page
// (review token br_n6dv3abrea) — verbatim text/name/location, `publish_at`
// date. Purchased-product pairing follows review_bo1's note.
//
// This is the strongest retail-proof quote in the brand's whole review pool
// ("we cannot keep these in stock"), which is why it leads the curated set in
// the prototype's dataset.
export const review_bo4: FaireReviewEntity = {
  token: "review_bo4",
  type: "review",
  brandName: "Beefy's Own",
  brandToken: "b_d6aqh4qdhb",
  reviewerName: "Christina",
  reviewerLocation: "Cairo, NY, United States",
  stars: 5,
  reviewText:
    "We cannot keep these in stock! They are so flavorful and perfectly cooked. Can't wait for more sizes. Hint, hint, wink, wink ;)",
  reviewDate: "May 21, 2026",
  reviewType: "brand",
  purchasedProductTokens: [
    "p_xz2fzy3cqc",
    "p_b7tqfj6z9q",
    "p_6sy6atfkhp",
    "p_vaba25wx8e",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-16T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
